import type {FacetTreeUiModel} from '../../../../models/ui/facets/facet-tree-ui.model';

export function refactorTreeByDividerMobileFacets(facets: FacetTreeUiModel[], dividerMobileFacets: string[]): {outerFacets: FacetTreeUiModel[], filteredFacets: FacetTreeUiModel[]} {
    let filteredFacets: FacetTreeUiModel[] = [];
    const outerFacets: FacetTreeUiModel[] = [];
    filteredFacets = facets.filter((facet) => {
        if(dividerMobileFacets.some(facetId => facet.id.includes(facetId))) {
          outerFacets.push(facet as FacetTreeUiModel);
          return false;
        }
        return true;
    });

    return {outerFacets, filteredFacets};
}
